import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, Target, RefreshCw } from "lucide-react";
import { API } from "@/auth";
import useSeo from "@/seo";

function displayDate(iso) {
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(iso || "");
  return m ? `${m[3]}-${m[2]}-${m[1]}` : iso || "";
}

export default function TargetNumberPublic() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const nav = useNavigate();

  useSeo({
    title: "Target Number Today | Morning Sunday Teer",
    description: "Today's Morning Sunday Teer target numbers, auto-updated every day.",
    path: "/target-numbers",
  });

  const load = () => {
    setLoading(true);
    axios.get(`${API}/target-numbers/today`).then((r) => setData(r.data)).finally(() => setLoading(false));
  };

  useEffect(() => {
    document.title = "Target Number | Morning Sunday Teer";
    load();
    const t = setInterval(load, 60000);
    return () => clearInterval(t);
  }, []);

  return (
    <div className="tp-shell" data-testid="target-number-page">
      <div className="tp-container">
        <button className="pr-back" data-testid="tp-back" onClick={() => nav("/")}><ArrowLeft /> Back</button>
        <div className="tp-title-row">
          <h1 className="pr-title">Target Number</h1>
          <button className="tp-refresh" onClick={load} aria-label="Refresh"><RefreshCw size={18} /></button>
        </div>
        <p className="pr-sub">Today's target numbers, updated daily.</p>

        <div className="tp-card tp-card--target" data-testid="target-card">
          <div className="tp-date-head">
            <Target size={18} />
            <span data-testid="target-date">{loading ? "Loading..." : (data?.date ? `TARGET · ${displayDate(data.date)}` : "TARGET NUMBER")}</span>
          </div>
          <div className="tp-value" data-testid="target-value">
            {loading ? "…" : (data?.numbers?.trim() || "Not available for today")}
          </div>
          <p className="tp-note">The values change automatically every day.</p>
        </div>
      </div>
    </div>
  );
}
